import { Slide } from "react-slideshow-image";

import slideImages from "../data/images";
import slideCost from "../data/costs";

import "react-slideshow-image/dist/styles.css";
import styles from "./Slider.module.css";

export default function Slider() {
  return (
    < div className="wrapper">
      <div className={styles.container}>
        <Slide easing="ease">
          {slideImages.map((slide, index) => {
            return (
              <div className={styles.slide} key={slide}>
                <div style={{ backgroundImage: `url(${slideImages[index]})`}}>
                  <div class = 'span-items'>
                    <span className = 'span-item'>Item {index + 1}  Cost: {slideCost[index]}</span>
                  </div>
                </div>
               </div> 
            );

          })}
        </Slide>
      </div>
    </div>
  );
}
